import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ButtonModule } from '@pc-ui/button';
import { DialogModule } from '@pc-ui/dialog';
import { TourDialogComponent } from './tour-dialog.component';

@NgModule({
  declarations: [TourDialogComponent],
  imports: [CommonModule, ButtonModule, MatDialogModule, DialogModule],
})
export class TourDialogModule {}
